/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, takeLatest, put } from "redux-saga/effects";
import { newRequest } from "../../../../api/token";
//import { customNotify } from "../../../../components/UI/ToastNotify";
import { getToken, getWrapperToken, isGlobalApolloError } from "../../../../utils/helpers/auth";
import {
  EURAIL_PASS_CHECKOUT,
  EURAIL_PASS_COUNTRIES,
  EURAIL_PASS_PRE_BOOK,
  EURAIL_PASS_SEARCH,
  GET_EURAIL_PASS_LIST,
} from "../../../actionTypes/Dashboard/eurailPassActionTypes";
import {
  eurailPassCheckoutAction,
  eurailPassCountriesAction,
  eurailPassPreBookAction,
  eurailPassSearchAction,
  getEurailPassListAction,
} from "../../../actions/Dashboard/eurailPassActions";
import {
  EP_CHECKOUT,
  EP_PRE_BOOK,
  EP_SEARCH,
  EP_SEARCH_RESULT,
  EURO_COUNTRIES,
} from "../../../gqlQueries/Dashboard/eurailQuery";
import { getNotificationMessage } from "../../../actions/localStorageActions";
import { UIMessage } from "../../../../components/UI/UIMessage";
import engLang from "../../../../locales/languages/Dashboard/DashboardEng.json";
import spanLang from "../../../../locales/languages/Dashboard/DashboardSpan.json";
import { getLanguageCode } from "../../../../locales/getlanguagecode";


function* eurailPassCountries(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: action?.payload?.input,
  };
  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: EURO_COUNTRIES,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.eurailCountries?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      yield put(
        eurailPassCountriesAction.FULLFILLED({
          data: apiData?.data?.eurailCountries?.responseData?.data?.suggestions,
          status: 200,
        })
      );
      action?.payload?.setError && action?.payload?.setError(true);
    } else {
      action?.payload?.setError && action?.payload?.setError(true);
       const message = {
                        isOpen: true,
                        mainHeader: "Something went wrong",
                        subHeader: "",
                        message: "Eurail Countries not available",
                        subReq: false,
              };
      yield put(getNotificationMessage(message));
      yield put(eurailPassCountriesAction.REJECTED());
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
    }
  } catch (error: any) {
   if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang,spanLang)?.promtsMessages?.fetchcountireswentwrong,
      closeIcon: true,
      onClose: () => action?.payload?.setLoading(false),
    });
    yield put(eurailPassCountriesAction.REJECTED());
    action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
    action?.payload?.setError && action?.payload?.setError(true);
  }
}

function* eurailPassSearch(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.apiPayload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: EP_SEARCH,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader(false);
    if (
      apiData?.data?.postURailPassSearch?.successTypeCode?.toLowerCase() ==
        "success" &&
      apiData?.data?.postURailPassSearch?.responseData?.status?.toLowerCase() ==
        "success"
    ) {
      const searchKeyValue = apiData?.data?.postURailPassSearch?.responseData;
      if (searchKeyValue?.data?.searchKey) {
        yield put(
          eurailPassSearchAction.FULLFILLED({
            data: searchKeyValue,
            status: 200,
          })
        );
      } else {
        const message = {
                        isOpen: true,
                        mainHeader: "Search Key is not available",
                        subHeader: "",
                        message: "",
                        subReq: false,
              };
        yield put(getNotificationMessage(message));
        yield put(eurailPassSearchAction.REJECTED());
      }
    } else {
      const message = {
                        isOpen: true,
                        mainHeader: "Something went wrong",
                        subHeader: "",
                        message: "Search Key is not available",
                        subReq: false,
              };
      yield put(getNotificationMessage(message));
      yield put(eurailPassSearchAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang,spanLang)?.promtsMessages?.timeoutmessage,
      closeIcon: true,
    });
    yield put(eurailPassSearchAction.REJECTED());
  }
}

function* getEurailPassList(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: action?.payload?.ts,
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: EP_SEARCH_RESULT,
      clientType: "BE",
      data: customHeaders,
    });
    // Do not setLoader(false) before FULLFILLED — avoids empty-state flash

    if (
      apiData?.data?.uRailPassList?.successTypeCode?.toLowerCase() ==
        "success" &&
      apiData?.data?.uRailPassList?.responseData?.status?.toLowerCase() ==
        "success"
    ) {
      yield put(
        getEurailPassListAction.FULLFILLED({
          data: apiData?.data?.uRailPassList?.responseData,
          status: 200,
        })
      );
      // Loader cleared by results page after list is applied
    } else {
      yield put(getEurailPassListAction.REJECTED());
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
      action?.payload?.setLoader && action?.payload?.setLoader(false);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
    UIMessage({
          messageText: getLanguageCode(engLang,spanLang)?.promtsMessages?.timeoutmessage,
          closeIcon: true,
        });
    yield put(getEurailPassListAction.REJECTED());
  }
}

function* eurailPassPreBook(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.apiPayload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: EP_PRE_BOOK,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader(false);
    if (
      apiData?.data?.postPassPrebook?.successTypeCode?.toLowerCase() ==
        "success" &&
      apiData?.data?.postPassPrebook?.responseData?.status?.toLowerCase() ==
        "success"
    ) {
      yield put(
        eurailPassPreBookAction.FULLFILLED({
          data: apiData?.data?.postPassPrebook?.responseData,
          status: 200,
        })
      );
    } else {
      const message = {
                        isOpen: true,
                        mainHeader: "pre-book failed",
                        subHeader: "",
                        message: "",
                        subReq: false,
              };
    yield put(getNotificationMessage(message));
      yield put(eurailPassPreBookAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang,spanLang)?.promtsMessages?.timeoutmessage,
      closeIcon: true,
    });
    yield put(eurailPassPreBookAction.REJECTED());
  }
}

function* eurailPassCheckout(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.apiPayload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: EP_CHECKOUT,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader(false);
    if (
      apiData?.data?.postURailPassCheckOut?.successTypeCode?.toLowerCase() ==
        "success" &&
      apiData?.data?.postURailPassCheckOut?.responseData?.status?.toLowerCase() ==
        "success"
    ) {
      action?.payload?.getCheckoutDetails?.(apiData?.data?.postURailPassCheckOut?.responseData?.data?.status?.toLowerCase());
      yield put(
        eurailPassCheckoutAction.FULLFILLED({
          data: apiData?.data?.postURailPassCheckOut?.responseData,
          status: 200,
        })
      );
    } else {
      if(action?.payload?.callingFrom == "online"){
        setTimeout(() => {
          window.location.href = "/";
        }, 5000);
      }
      action?.payload?.getCheckoutDetails?.("pending");
      yield put(eurailPassCheckoutAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader(false);
    if(action?.payload?.callingFrom == "online"){
      setTimeout(() => {
        window.location.href = "/";
      }, 5000);
    }
    action?.payload?.getCheckoutDetails?.("pending");
    yield put(eurailPassCheckoutAction.REJECTED());
  }
}

export function* watcherEurailPass() {
  yield takeLatest(EURAIL_PASS_COUNTRIES.STARTED, eurailPassCountries);
  yield takeLatest(EURAIL_PASS_SEARCH.STARTED, eurailPassSearch);
  yield takeLatest(GET_EURAIL_PASS_LIST.STARTED, getEurailPassList);
  yield takeLatest(EURAIL_PASS_PRE_BOOK.STARTED, eurailPassPreBook);
  yield takeLatest(EURAIL_PASS_CHECKOUT.STARTED, eurailPassCheckout);
}

export const sagas = [watcherEurailPass];
